import { render, staticRenderFns } from "./AICartoon_Questions.vue?vue&type=template&id=2560929e&scoped=true"
import script from "./AICartoon_Questions.vue?vue&type=script&lang=js"
export * from "./AICartoon_Questions.vue?vue&type=script&lang=js"
import style0 from "./AICartoon_Questions.vue?vue&type=style&index=0&id=2560929e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2560929e",
  null
  
)

export default component.exports